import React from "react";
import ReactDOM from "react-dom/client";
import esp from "antd/es/locale/es_ES";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import { store } from "./redux/store";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	<Provider store={store}>
		<ConfigProvider locale={esp}>
			<App />
		</ConfigProvider>
	</Provider>
);
